import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=beb974aa&scoped=true"
import script from "./org-list.vue?vue&type=script&lang=ts"
export * from "./org-list.vue?vue&type=script&lang=ts"
import style0 from "./org-list.vue?vue&type=style&index=0&id=beb974aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb974aa",
  null
  
)

export default component.exports